module.exports = __webpack_public_path__ + "img/logo_4.23e7da6a.png";